// frontend/src/pages/dashboards/RestrictedTag.jsx
// Phase 4 step 14d-3: "Only specific people", on the dashboard list and under
// a dashboard's title, when the dashboard is restricted (the server's
// `access`). Beside SharedTag; the two never show together, since a
// restricted dashboard is never public (brief decision 4).
import React from 'react';
import { Lock } from 'lucide-react';

export default function RestrictedTag() {
  return (
    <span className="inline-flex items-center gap-1 rounded-md bg-amber-500/10 px-1.5 py-0.5 text-[11px] font-medium text-amber-300 ring-1 ring-amber-500/20"
      title="Only admins and the people named on it can open this dashboard" data-restricted-tag>
      <Lock className="h-3 w-3" aria-hidden="true" /> Only specific people
    </span>
  );
}
